import axios from '@/shared/plugins/Axios'

function Requests () {
  async function fetchCategories () {
    try {
      const { data } = await axios.get('/category-list')
      return data
    } catch (error) {
      console.log(error)
    }
  }

  async function loginWithLinkedIn() {
    try {
      const { data } = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/social-login/linkedin/generate-url`)
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function login(formData) {
    try {
      const { data } = await axios.post(`${process.env.VUE_APP_API_BASE_URL}/login`, formData)
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function forgotPassword(email) {
    try {
      const { data } = await axios.post(`${process.env.VUE_APP_API_BASE_URL}/forgot-password`, email)
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function registerFreelancer (formData) {
    try {
      const { data } = await axios.post('/register', formData)
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function logout (token) {
    try {
      const { data } = await axios.post(`${process.env.VUE_APP_API_BASE_URL}/logout`, token)
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function resendAccountVerificationEmail () {
    try {
      const { data } = await axios.post('/resend-verify-email')
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function verifyEmail (payload) {
    try {
      axios.defaults.headers.common.Authorization = `Bearer ${payload.userToken}`
      const { data } = await axios.post(`/verify-email/${payload.mailToken}`)
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function checkProfileStatus () {
    try {
      console.log('check profile status')
      const { data } = await axios.post('/email-verification-status')
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function validateAuthToken() {
    try {
      const { data } = await axios.post(`${process.env.VUE_APP_API_BASE_URL}/validate-token`)
      return data
    } catch (error) {
      return error.response.data
    }
  }

  return {
    fetchCategories,
    registerFreelancer,
    logout,
    resendAccountVerificationEmail,
    verifyEmail,
    checkProfileStatus,
    validateAuthToken,
    login,
    forgotPassword,
    loginWithLinkedIn
  }
}

export default Requests()